module.exports = "/images/vendor/flag-icon-css/flags/1x1/gb.svg?5db9fea0ec9e05cfb98e7387be5d0aa7";